/**
 * Gedeelde vorm en regels van de pagina-editor (ContentEditor en zijn velden). Puur, zonder schermen.
 */
export type Json = string | number | boolean | null | Json[] | { [key: string]: Json }

/** Hoe een veld op díe plek heet (data/pageSections.ts), als het algemene label niet genoeg zegt. */
export type FieldOverrides = Record<string, { label: string; hint?: string }>

/** Langer dan dit wordt een tekstvak in plaats van één regel. */
export const LONG_TEXT = 80
/** Ongeveer zoveel tekens per regel in een tekstvak; zo groeit het vak mee (3–8 regels). */
const CHARS_PER_ROW = 90
export const rowsFor = (text: string) => Math.min(8, Math.max(3, Math.ceil(text.length / CHARS_PER_ROW)))

export const isObject = (v: Json): v is { [key: string]: Json } => typeof v === 'object' && v !== null && !Array.isArray(v)

/** Een leeg exemplaar met dezelfde vorm, voor "toevoegen" in een lijst. */
export const emptied = (v: Json): Json => {
  if (typeof v === 'string') return ''
  if (typeof v === 'number') return 0
  if (typeof v === 'boolean') return false
  if (Array.isArray(v)) return []
  if (isObject(v)) return Object.fromEntries(Object.entries(v).map(([k, x]) => [k, emptied(x)]))
  return null
}

/** Eerste stukje tekst uit een item, als titel van de kaart. */
export const titleOf = (v: Json): string => {
  if (typeof v === 'string') return v
  if (isObject(v)) {
    for (const key of ['title', 'name', 'text', 'code', 'quote', 'label']) {
      const x = v[key]
      if (typeof x === 'string' && x) return x
    }
  }
  return ''
}

/**
 * Geneste groepen zonder kaders: een zachte vlakkleur die per laag wisselt (wit paneel → zand →
 * wit → …), zodat je ziet wat bij elkaar hoort zonder doos-in-doos.
 */
export const tint = (depth: number) => (depth % 2 === 1 ? 'bg-shell' : 'bg-white')
